import type { ApiRoute, NoBody, NoQueryParams } from "../api"
import type { FinancingView } from "../vehicleDetails/overview/financing/FinancingView"

export interface GetFinancingViewPathParams {
	inventoryId: string
}

export const getFinancingViewRoute: ApiRoute<GetFinancingViewPathParams, NoQueryParams, NoBody, FinancingView> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/financing`,
	method: "get",
	path: "/vehicles/:inventoryId/financing",
}
